import {v4 as uuidv4} from 'uuid';
import {SearchKeywordResultVo} from '../../common/shared/api/nicolas/vo/SearchKeywordResultVo.interface';
import {SearchKeywordSortTypeVo} from '../../common/shared/api/nicolas/vo/SearchKeywordSortTypeVo.enum';
import {Maybe, SearchKeyword, User} from '../generated/types';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSearchSortType} from './SearchSortType';
import {createSortOption} from './SortOption';

export function createSearchKeyword(
  userInfo: Maybe<User>,
  {
    cat_opt_list,
    is_complete,
    is_end,
    keyword,
    list,
    selected_cat_opt,
    selected_sort_opt,
    sort_opt_list,
    total_count,
  }: SearchKeywordResultVo,
  page: number
): SearchKeyword {
  const selectedSortOption = createSortOption({sortOptVo: selected_sort_opt});

  return {
    id: uuidv4(),
    total: total_count,
    categoryOptionList: cat_opt_list.map(opt =>
      createSortOption({sortOptVo: opt})
    ),
    showOnlyComplete: is_complete,
    isEnd: is_end,
    keyword,
    list: list.map(item => ({
      ...createNormalListViewItem(userInfo, {
        searchCommonItemSeriesDto: item,
        // 전체 카테고리인 경우에만 대분류 노출합니다.
        shouldShowCategory: selected_cat_opt.param === ALL_CATEGORY_PARAM,
      }),
    })),
    selectedCategoryOption: createSortOption({sortOptVo: selected_cat_opt}),
    selectedSortOption: {
      ...selectedSortOption,
      param: createSearchSortType(
        selectedSortOption.param as SearchKeywordSortTypeVo
      ),
    },
    sortOptionList: sort_opt_list
      .map(opt => createSortOption({sortOptVo: opt}))
      .map(opt => ({
        ...opt,
        param: createSearchSortType(opt.param as SearchKeywordSortTypeVo),
      })),
    page,
  };
}

const ALL_CATEGORY_PARAM = '0';
